/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from 'react';
import { connect, useSelector } from "react-redux";

import Style from '../../../pme/screens/dashboard/style';

import { actions } from '../../../../../store/reducers/dashboard';
import { actions as authActions } from '../../../../../store/reducers/authentication';
import { useTranslation } from 'react-i18next';
import ProjectLayout from '../../../pme/screens/dashboard/layouts/project';
import { getSourceName } from '../../../../../helpers/user';

const ProjectDashboard = ({
  authentication: { user, selectedProject, sourceId },
  dashboard: {
    pme: {
      retrived,
      data,
    }
  },
  project: { data: { projects }, retrived: projectsRetrived },
  PmeDashboardGet,
  PmeProjectGet,
  changeSourceId,
  sidebarCollapsed = false,
}) => {
  const [projectData, setProjectData] = useState(null);
  const { t } = useTranslation();
  const [initialFetchingDone, setInitialFetchingDone] = useState(false);
  const { sources } = useSelector((state) => state.project);

  const isOwnData = useMemo(() =>
    selectedProject === 'myOwnData' ? true : sourceId !== 'overview'
    , [selectedProject, sourceId]);

  useEffect(() => {
    if (projects && projects.length && selectedProject) {
      const pData = projects.find(p => p.id === selectedProject);
      setProjectData(pData);
    }
  }, [projects, selectedProject]);

  useEffect(() => {
    if (isOwnData) {
      PmeDashboardGet(() => setInitialFetchingDone(true));
    } else {
      PmeProjectGet(() => setInitialFetchingDone(true));
    }
  }, []);

  useEffect(() => {
    if (retrived && initialFetchingDone) {
      if (isOwnData) {
        PmeDashboardGet();
      } else {
        PmeProjectGet();
      }
    }
  }, [user.language, sourceId, selectedProject]);

  const participantOrgName = useMemo(() => {
    const s = sourceId || localStorage.getItem('source');
    if (projectData && s) {
      const participant = sources.find((p) => p.authorId === s);
      if (participant) {
        return getSourceName(participant);
      }
    }
    return null;
  }, [sourceId, projectData, sources]);

  if (!isOwnData && sourceId === 'overview') {
    return (
      <Style className="semibold form-input-output app-content project-dashboard">
        <ProjectLayout
          t={t}
          data={data}
          selectedProject={selectedProject}
          language={user.language}
          projectData={projectData}
          sourceId={sourceId}
          isOwnData={selectedProject === 'myOwnData'}
          user={user}
          PmeDashboardGet={PmeProjectGet}
          organisationName={
            ((sourceId || localStorage.getItem('source')) && selectedProject !== 'myOwnData') ? participantOrgName : user?.organisationName
          }
          retrived={retrived}
          sources={sources}
          sidebarCollapsed={sidebarCollapsed}
        />
      </Style>
    );
  }

  return null;
}

export default connect(
  ({ authentication, dashboard, project }) =>
    ({ authentication, dashboard, project }),
  { ...actions, ...authActions },
)(ProjectDashboard);
